import "core-js/stable"
import "regenerator-runtime/runtime"
import React from 'react'
import Select from "../Select.js"

const SelectDays = (props) => {
  let days = []
  for (let index = 1; index <= 31; index++) {
    days.push({
      value: index,
      name: index
    })
  }

  return (
    <Select
      label={props.label}
      id={props.id}
      name={props.name}
      options={days}
      value={props.value}
      className={props.className}
      onClick={props.onClick}
      onChange={props.onChange}
      setState={props.setState}
      required={props.required}
    />
  )
}

export default SelectDays